import axios from 'axios';
import { encrypt } from "./Encriptacion";


const apiUrl = process.env.REACT_APP_API_URL
const tokenEncrypt = process.env.REACT_APP_CLAVE_ENCRYPTION


const api = axios.create({
    baseURL: apiUrl,
    timeout: 100000,
});

api.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                sessionStorage.setItem("auth",encrypt("false",tokenEncrypt));
            }
            console.error('Error en la respuesta:', error.response.data);
        } else if (error.request) {
            console.error('Error en la solicitud:', error.request);
        } else {
            console.error('Error al configurar la solicitud:', error.message);
        }
        return Promise.reject(error);
    }
);

export default api;